import { Component, Input } from '@angular/core';
import { OperationDescriptionForReview } from '../../models/operation-description.model';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-surgery-details',
  templateUrl: './surgery-details.component.html',
  imports: [TranslateModule]
})
export class SurgeryDetailsComponent {
  @Input() operationDescription: OperationDescriptionForReview;
  @Input() patientAge: string;
}
